import React from 'react';
import { Inspection } from '../../services/inspectionsApi';
import { ui } from '../../styles/shared';
import { todayStr } from '../../utils/format';

// Små hjälpare som flera flikar på egenkontroll-sidan delar.

/** Knapp i valfri färg, samma form som ui.btnPrimary. */
export const btn = (bg: string, color = 'white'): React.CSSProperties => ({ ...ui.btnPrimary, backgroundColor: bg, color });
/** Liten knapp i tabeller, samma form som ui.btnLight. */
export const btnSmall = (bg: string, color = 'white'): React.CSSProperties => ({ ...ui.btnLight, backgroundColor: bg, color });

/** Sant om raden hör till vald grupp ('' = alla grupper). */
export const inGroup = (group: string, g: string | null | undefined): boolean => !group || g === group;

/** Statusmärke för en kontroll: att göra, försenad, gjord, åtgärd pågår ... */
export const StatusBadge: React.FC<{ i: Inspection }> = ({ i }) => {
    const map: Record<string, [string, string]> = {
        pending: i.has_draft ? ['Påbörjad', '#6f42c1'] : ['Att göra', '#0d6efd'],
        overdue: ['Försenad', '#dc3545'],
        action: [i.action_due_date && i.action_due_date < todayStr() ? 'Åtgärd försenad' : 'Åtgärd pågår', i.action_due_date && i.action_due_date < todayStr() ? '#dc3545' : '#fd7e14'],
        done: i.has_deviation ? ['Gjord, avvikelse', '#fd7e14'] : i.no_need ? ['Utfört, inget behov', '#20c997'] : ['Gjord', '#28a745'],
        skipped: ['Hoppades över', '#6c757d'],
    };
    const [text, color] = map[i.status] ?? [i.status, '#666'];
    return <span style={ui.badge(color)}>{text}</span>;
};
